module.exports = __webpack_public_path__ + "static/media/synopsis-hiw-image-1@2x.78c4c545.png";